import { Facebook, Instagram, Linkedin, Building2, Twitter } from 'lucide-react';

export const platforms = [
  { id: 'facebook', name: 'Facebook', icon: Facebook, color: 'bg-blue-600' },
  { id: 'instagram', name: 'Instagram (via Facebook)', icon: Instagram, color: 'bg-pink-600' },
  { id: 'instagram_direct', name: 'Instagram Direct', icon: Instagram, color: 'bg-purple-600' },
  { id: 'linkedin', name: 'LinkedIn', icon: Linkedin, color: 'bg-blue-700' },
  { id: 'google_business', name: 'Google Business', icon: Building2, color: 'bg-red-600' },
  { id: 'x', name: 'X (Twitter)', icon: Twitter, color: 'bg-black' },
];

export const timezones = [
  { id: 'Europe/Warsaw', label: 'Warszawa (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/London', label: 'Londyn (UTC+0/+1)', region: 'Europa' },
  { id: 'Europe/Paris', label: 'Paryż (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Berlin', label: 'Berlin (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Madrid', label: 'Madryt (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Rome', label: 'Rzym (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Amsterdam', label: 'Amsterdam (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Brussels', label: 'Bruksela (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Vienna', label: 'Wiedeń (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Prague', label: 'Praga (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Budapest', label: 'Budapeszt (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Stockholm', label: 'Sztokholm (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Oslo', label: 'Oslo (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Copenhagen', label: 'Kopenhaga (UTC+1/+2)', region: 'Europa' },
  { id: 'Europe/Helsinki', label: 'Helsinki (UTC+2/+3)', region: 'Europa' },
  { id: 'Europe/Athens', label: 'Ateny (UTC+2/+3)', region: 'Europa' },
  { id: 'Europe/Bucharest', label: 'Bukareszt (UTC+2/+3)', region: 'Europa' },
  { id: 'Europe/Kiev', label: 'Kijów (UTC+2/+3)', region: 'Europa' },
  { id: 'Europe/Moscow', label: 'Moskwa (UTC+3)', region: 'Europa' },
  { id: 'Europe/Istanbul', label: 'Stambuł (UTC+3)', region: 'Europa' },
  { id: 'Europe/Lisbon', label: 'Lizbona (UTC+0/+1)', region: 'Europa' },
  { id: 'Europe/Dublin', label: 'Dublin (UTC+0/+1)', region: 'Europa' },
  { id: 'Europe/Zurich', label: 'Zurych (UTC+1/+2)', region: 'Europa' },

  { id: 'America/New_York', label: 'Nowy Jork (UTC-5/-4)', region: 'Ameryka' },
  { id: 'America/Chicago', label: 'Chicago (UTC-6/-5)', region: 'Ameryka' },
  { id: 'America/Denver', label: 'Denver (UTC-7/-6)', region: 'Ameryka' },
  { id: 'America/Los_Angeles', label: 'Los Angeles (UTC-8/-7)', region: 'Ameryka' },
  { id: 'America/Phoenix', label: 'Phoenix (UTC-7)', region: 'Ameryka' },
  { id: 'America/Toronto', label: 'Toronto (UTC-5/-4)', region: 'Ameryka' },
  { id: 'America/Vancouver', label: 'Vancouver (UTC-8/-7)', region: 'Ameryka' },
  { id: 'America/Mexico_City', label: 'Meksyk (UTC-6/-5)', region: 'Ameryka' },
  { id: 'America/Sao_Paulo', label: 'Sao Paulo (UTC-3)', region: 'Ameryka' },
  { id: 'America/Buenos_Aires', label: 'Buenos Aires (UTC-3)', region: 'Ameryka' },
  { id: 'America/Lima', label: 'Lima (UTC-5)', region: 'Ameryka' },
  { id: 'America/Bogota', label: 'Bogota (UTC-5)', region: 'Ameryka' },
  { id: 'America/Santiago', label: 'Santiago (UTC-4/-3)', region: 'Ameryka' },

  { id: 'Asia/Tokyo', label: 'Tokio (UTC+9)', region: 'Azja' },
  { id: 'Asia/Shanghai', label: 'Szanghaj (UTC+8)', region: 'Azja' },
  { id: 'Asia/Hong_Kong', label: 'Hongkong (UTC+8)', region: 'Azja' },
  { id: 'Asia/Singapore', label: 'Singapur (UTC+8)', region: 'Azja' },
  { id: 'Asia/Seoul', label: 'Seul (UTC+9)', region: 'Azja' },
  { id: 'Asia/Bangkok', label: 'Bangkok (UTC+7)', region: 'Azja' },
  { id: 'Asia/Jakarta', label: 'Dżakarta (UTC+7)', region: 'Azja' },
  { id: 'Asia/Manila', label: 'Manila (UTC+8)', region: 'Azja' },
  { id: 'Asia/Kolkata', label: 'Kalkuta (UTC+5:30)', region: 'Azja' },
  { id: 'Asia/Mumbai', label: 'Bombaj (UTC+5:30)', region: 'Azja' },
  { id: 'Asia/Dubai', label: 'Dubaj (UTC+4)', region: 'Azja' },
  { id: 'Asia/Riyadh', label: 'Rijad (UTC+3)', region: 'Azja' },
  { id: 'Asia/Tel_Aviv', label: 'Tel Awiw (UTC+2/+3)', region: 'Azja' },
  { id: 'Asia/Karachi', label: 'Karaczi (UTC+5)', region: 'Azja' },
  { id: 'Asia/Dhaka', label: 'Dhaka (UTC+6)', region: 'Azja' },
  { id: 'Asia/Kuala_Lumpur', label: 'Kuala Lumpur (UTC+8)', region: 'Azja' },
  { id: 'Asia/Taipei', label: 'Tajpej (UTC+8)', region: 'Azja' },
  { id: 'Asia/Ho_Chi_Minh', label: 'Ho Chi Minh (UTC+7)', region: 'Azja' },

  { id: 'Australia/Sydney', label: 'Sydney (UTC+10/+11)', region: 'Australia i Oceania' },
  { id: 'Australia/Melbourne', label: 'Melbourne (UTC+10/+11)', region: 'Australia i Oceania' },
  { id: 'Australia/Brisbane', label: 'Brisbane (UTC+10)', region: 'Australia i Oceania' },
  { id: 'Australia/Perth', label: 'Perth (UTC+8)', region: 'Australia i Oceania' },
  { id: 'Pacific/Auckland', label: 'Auckland (UTC+12/+13)', region: 'Australia i Oceania' },
  { id: 'Pacific/Fiji', label: 'Fidżi (UTC+12)', region: 'Australia i Oceania' },
  { id: 'Pacific/Honolulu', label: 'Honolulu (UTC-10)', region: 'Australia i Oceania' },

  { id: 'Africa/Cairo', label: 'Kair (UTC+2)', region: 'Afryka' },
  { id: 'Africa/Johannesburg', label: 'Johannesburg (UTC+2)', region: 'Afryka' },
  { id: 'Africa/Lagos', label: 'Lagos (UTC+1)', region: 'Afryka' },
  { id: 'Africa/Nairobi', label: 'Nairobi (UTC+3)', region: 'Afryka' },
  { id: 'Africa/Casablanca', label: 'Casablanca (UTC+0/+1)', region: 'Afryka' },

  { id: 'UTC', label: 'UTC (Czas uniwersalny)', region: 'Inne' },
];

export const cycleOptions = [
  { id: 'once', label: 'Jednorazowo' },
  { id: 'daily', label: 'Codziennie' },
  { id: 'weekly', label: 'Co tydzień' },
  { id: 'monthly', label: 'Co miesiąc' },
  { id: 'custom', label: 'Własny' },
];

// Dni tygodnia w tym samym formacie co w Calendar.tsx
export const weekDays = [
  { id: 'mon', label: 'Pon' },
  { id: 'tue', label: 'Wt' },
  { id: 'wed', label: 'Śr' },
  { id: 'thu', label: 'Czw' },
  { id: 'fri', label: 'Pt' },
  { id: 'sat', label: 'Sob' },
  { id: 'sun', label: 'Nd' },
];